import constate from "constate";
import { useState } from "react";
import { GroupShiftInvite } from "../ShiftInviteReview";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlag } from "@src/constants/FEATURE_FLAGS";

function useShiftInvite() {
  const [groupedShiftInvite, setGroupedShiftInvite] = useState<GroupShiftInvite>();
  const ldFlags = useFlags();
  const isMultiShiftInvitesEnabled = ldFlags[FeatureFlag.ROLLOUT_MULTI_SHIFT_INVITES] ?? false;

  return {
    groupedShiftInvite,
    setGroupedShiftInvite,
    isMultiShiftInvitesEnabled,
  };
}

export const [ShiftInviteProvider, useShiftInviteContext] = constate(useShiftInvite);
